import { render, staticRenderFns } from "./ActivityPost.vue?vue&type=template&id=3f5cf080&"
import script from "./ActivityPost.vue?vue&type=script&lang=js&"
export * from "./ActivityPost.vue?vue&type=script&lang=js&"
import style0 from "./ActivityPost.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports